import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { QineticImport, QineticImportService, QineticImportStatus } from 'src/app/core/qinetic-import.service';
import { StepsService } from 'src/app/core/steps.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-steps-sync-dialog',
  templateUrl: './steps-sync-dialog.component.html',
  styleUrls: ['./steps-sync-dialog.component.scss'],
})
export class StepsSyncDialogComponent {
  is_sync_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<StepsSyncDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private utils_service: UtilsService,
    private qinetic_import_service: QineticImportService,
    private error_service: ErrorService,
  ) {}

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onSyncClick(event: any): void {
    const file: File = event.target?.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      const text_file: string = reader.result as string;
      this.createQineticImport(text_file);
    };
    reader.readAsText(file);
  }

  createQineticImport(upload: string): void {
    this.is_sync_running = true;
    this.qinetic_import_service.create(upload).subscribe({
      next: response => {
        const qinetic_import: QineticImport = response.data;
        this.readQineticImport(qinetic_import.qinetic_import_id as string);
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_sync_running = false;
      },
    });
  }

  readQineticImport(qinetic_import_id: string): void {
    this.is_sync_running = true;
    this.qinetic_import_service.read(qinetic_import_id).subscribe({
      next: response => {
        const qinetic_import: QineticImport = response.data;
        if (qinetic_import.status == QineticImportStatus.pending) {
          this.readQineticImport(qinetic_import_id);
        }

        if (qinetic_import.status == QineticImportStatus.completed) {
          this.dialog_ref.close({ success: true });
          this.is_sync_running = false;
        }

        if (qinetic_import.status == QineticImportStatus.failed) {
          this.dialog_ref.close({ failure: true, failure_msg: qinetic_import.failure_cause });
          this.is_sync_running = false;
        }
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_sync_running = false;
      },
    });
  }
}
